import { render } from "./VideoFavorite.vue?vue&type=template&id=5b2aeaf9"
import script from "./VideoFavorite.vue?vue&type=script&lang=ts"
export * from "./VideoFavorite.vue?vue&type=script&lang=ts"
script.render = render

export default script